(() => {
  if (window.mooseLogHomepageHeroReady) return;
  window.mooseLogHomepageHeroReady = true;

  function initialize(root) {
    if (!root || root.classList.contains('is-enhanced')) return;
    root.classList.add('is-enhanced');

    let touchStart = null;
    root.addEventListener('touchstart', (event) => {
      touchStart = null;
      if (event.touches.length !== 1 || event.target.closest('a, button, input, select, textarea')) return;
      touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });

    root.addEventListener('touchend', (event) => {
      if (!touchStart || event.changedTouches.length !== 1 || event.touches.length) return;
      const deltaX = event.changedTouches[0].clientX - touchStart.x;
      const deltaY = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.5) return;

      const slides = root.querySelectorAll('[data-hero-slide]');
      if (slides.length < 2) return;
      const activeIndex = Array.from(slides).findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) return;
      showSlide(root, (activeIndex + (deltaX < 0 ? 1 : -1) + slides.length) % slides.length);
    }, { passive: true });

    root.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
  }

  function loadSlideImage(slide) {
    const image = slide.querySelector('picture img');
    if (!image) return Promise.resolve(false);
    if (image.heroLoadPromise) return image.heroLoadPromise;
    if (!image.dataset.src) return Promise.resolve(true);

    slide.querySelectorAll('picture source[data-srcset]').forEach((source) => {
      source.srcset = source.dataset.srcset;
      delete source.dataset.srcset;
    });
    image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    delete image.dataset.srcset;
    delete image.dataset.src;

    image.heroLoadPromise = new Promise((resolve) => {
      if (image.complete) {
        resolve(image.naturalWidth > 0);
        return;
      }
      image.addEventListener('load', () => resolve(true), { once: true });
      image.addEventListener('error', () => resolve(false), { once: true });
    });
    return image.heroLoadPromise;
  }

  async function showSlide(root, index, focusIndicator = false) {
    const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    const target = slides[index];
    if (!target || !slides.length) return;

    root.heroChangeToken = (root.heroChangeToken || 0) + 1;
    const token = root.heroChangeToken;
    if (!(await loadSlideImage(target)) || token !== root.heroChangeToken) return;

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('is-active', active);
      slide.toggleAttribute('inert', !active);
      if (active) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    });

    root.querySelectorAll('[data-hero-target]').forEach((button) => {
      const active = Number(button.dataset.heroTarget) === index;
      button.classList.toggle('is-active', active);
      if (active) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });

    if (focusIndicator) {
      target.querySelector(`[data-hero-target="${index}"]`)?.focus({ preventScroll: true });
    }
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-homepage-hero]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hero-target]');
    const root = button?.closest('[data-homepage-hero]');
    if (root) showSlide(root, Number(button.dataset.heroTarget), true);
  });

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-hero-slide]');
    const root = slide?.closest('[data-homepage-hero]');
    if (root) showSlide(root, Number(slide.dataset.heroSlide));
  });
})();
